import { Button } from "@/components/buttons/Button";
import { Link } from "react-router-dom";
import { routes } from "@/common/utils/routes";
import RightArrowIcon from "@/common/images/icons/right_arrow.svg?react";
import { INiche } from "@/common/services/types";
import { useDeviceType } from "@/common/hooks";
import { deviceTypeEnum } from "@/common/utils/device";
import { useFollowNicheQueries } from "@/common/hooks/useFollowNicheQueries";

interface IProps {
  niche: INiche;
  following: boolean;
  isLink?: boolean;
  onFollow: (id: string, status: boolean) => void;
  onPreviewClick?: () => void;
}

export const NichePreviewButton = ({ niche, following, isLink, onFollow, onPreviewClick }: IProps) => {
  const isDesktop = useDeviceType() === deviceTypeEnum.DESKTOP;
  const { onFollowAction: handleFollow } = useFollowNicheQueries({ nicheId: niche.id, following, sendFollowState: onFollow });

  return (
    <div className="NichePreviewButton">
      { !isLink ?
        (
          <Button variant={following ? "secondary" : "primary"} size={isDesktop ? "s" : "xs"} onClick={handleFollow}>
            {following ? "Leave" : "Join"}
          </Button>
        )
        : (
          <Link
            className="Button Button_secondary Button_isRound Button_xs"
            to={routes.niche(niche.id)}
            aria-label={`Link to ${routes.niche(niche.id)}`}
            onClick={onPreviewClick}
          >
            <RightArrowIcon />
          </Link>
        )
      }
    </div>
  );
};
